import { useApplyColorModeContrast } from "./useColorModeContrast";
import { useApplyColorVisionDeficiency } from "./useColorVisionDeficiency";

/**
 * Parent hook for all display mode preferences.
 * Called by DBBL's LibraryProvider (see `providers/displayModesEffects.tsx`).
 * Resolves and applies all accessibility display modes to the DOM.
 */
export const useDisplayModes = () => {
  const colorModeContrast = useApplyColorModeContrast();
  const colorVisionDeficiency = useApplyColorVisionDeficiency();

  return {
    colorModeContrast,
    colorVisionDeficiency,
    // future: colorScheme
    // future: dyslexiaMode
  };
};
